import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

import { ActionPlanSidePaneData } from 'app/providers/bridge-api/dashboard.service';

@Injectable()
export class ActionPlanSidePaneService {
  private readonly sidePaneDataList: ActionPlanSidePaneData[];

  private readonly sidePaneDataListChangeSub = new Subject<ActionPlanSidePaneData[]>();

  readonly sidePaneDataListChanged$ = this.sidePaneDataListChangeSub.asObservable();

  constructor() {
    this.sidePaneDataList = [];
  }

  load(dataList: ActionPlanSidePaneData[], page: number): void {
    this.sidePaneDataList.splice(0, this.sidePaneDataList.length);

    this.add(dataList.filter((d) => d.page === page));
  }

  add(dataList: ActionPlanSidePaneData[]): void {
    this.sidePaneDataList.push(...dataList);

    this.emit();
  }

  remove(data: ActionPlanSidePaneData): void {
    this.sidePaneDataList.splice(this.sidePaneDataList.indexOf(data), 1);

    this.emit();
  }

  private emit(): void {
    this.sidePaneDataListChangeSub.next(this.sidePaneDataList);
  }
}
